import React from 'react';
import styles from './style.module.scss';

export default function Spin({ size, type }) {
  return (
    <span
      className={`${styles.loader} ${styles[type]}`}
      style={{
        width: size,
        height: size,
      }}
    />
  );
}
